import createGetFormInitialValues from './selectors/getFormInitialValues';
import plain from './structure/plain';
export default createGetFormInitialValues(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/getFormInitialValues.js
// module id = cHlX
// module chunks = 1